(function () {
  var header = document.querySelector('.header-wrapper--transparent');
  if (!header) return;

  var threshold = 50;
  var scrolled = false;
  var ticking = false;

  function update() {
    var shouldBeScrolled = window.scrollY > threshold;
    if (shouldBeScrolled !== scrolled) {
      scrolled = shouldBeScrolled;
      header.classList.toggle('scrolled', scrolled);
    }
    ticking = false;
  }

  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    },
    { passive: true }
  );

  update();
})();
